import PropTypes from "prop-types";
import * as React from "react";
import { HeartIcon } from "../../../themeV2";
import css from "./ShopCard.module.css";

export default function LikeButton({ isFavourite, onClick }) {
  return (
    <button
      onClick={onClick}
      className={[css.likeButton, isFavourite && css.likeButtonFavourite]
        .filter(Boolean)
        .join(" ")}
    >
      <HeartIcon
        pathClassName={isFavourite ? css.heartFilled : undefined}
        strokeWidth={isFavourite ? 0 : 2}
      />
    </button>
  );
}

LikeButton.propTypes = {
  isMobile: PropTypes.bool,
  isFavourite: PropTypes.bool,
  onClick: PropTypes.func,
};
